'use client';
import styled from 'styled-components';

export const StyledCtaButton = styled.div`
  display: flex;
  justify-content: ${props => {
    switch (props.$alignment) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      case 'center':
      default:
        return 'center';
    }
  }};
`;
